<template>
    <span v-if="item">
        <strong>HD Sync:</strong>&nbsp;
        <a href="javascript:void(0);" title="Sync Docs URL" class="text-warning" @click="copySyncDocsUrl(item)"><i
                class="fa fa-link"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Sync URL" class="text-info" @click="copyHDSyncURL(item)"><i
                class="fa fa-sync"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Sync JSON" class="text-info" @click="copyHDSyncJSON(item)"><i
                class="fa fa-file"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Article Link" class="text-info" @click="copyHDArticleLink(item)"><i
                class="fa fa-info"></i></a>&nbsp;
        <a href="javascript:void(0);" title="GitHub to HD Create URL" class="text-primary"
            @click="copyGitHubCreateHDURL(item)"><i class="fa fa-plus"></i></a>&nbsp;<br /><br />

        <strong>Git Sync:</strong>&nbsp;
        <a href="javascript:void(0);" title="GitHub Sync Comment" class="text-primary"
            @click="copyGitHubCommentURL(item)"><i class="fa fa-comment-alt"></i></a>&nbsp;
        <a href="javascript:void(0);" title="GitHub Sync URL" class="text-primary" @click="copyGitHubStatusURL(item)"><i
                class="fa fa-sync"></i></a>&nbsp;
        <a href="javascript:void(0);" title="GitHub Aritcle Link" class="text-primary"
            @click="copyGitHubArticleLink(item)"><i class="fa fa-info"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD to ADO Create URL" class="text-danger"
            @click="copyHDAutoCreateURL(item)"><i class="fa fa-plus"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD to ADO Create JSON" class="text-danger"
            @click="copyHDAutoCreateJSON(item)"><i class="fa fa-file"></i></a>&nbsp;<br />
    </span>
</template>
<style scoped>
    .fa{
        font-size: 1.5rem;
    }
</style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins:[CommonFactory],
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        onCopy(e){
            this.userMsg={show:true,type:'primary',list:['You just copied: ' + e.text]};
        },
        async doCopyVal(message,successMsg){
            const _self=this;
            let isCopied=await _self.$copyText(message)
            if(isCopied){
                _self.userMsg={show:true,type:'primary',list:['You just copied: ' + successMsg?successMsg:message]};
            }
        },
        copyHDAutoCreateJSON(item){
            const _self=this;
            let hdJSONString;
            switch(item.requestType){
                case 'zendesk-github':
                    hdJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "brandname":"{{ticket.brand.name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl": "{{githubUrl}}",
                            "attachments1":"{{ticket.latest_comment.attachments}}",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.title}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": 45,
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "githubUrl": "{{githubUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{current_user.id}}",
                                "email": "{{current_user.email}}",
                                "name": "{{current_user.name}}"
                            }
                        }
                    }
                    break;
                    case 'freshdesk-github':
                    hdJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_url": "{{hdLoginUrl}}/a/tickets/{{ticket.id}}",
                            "brandname": "{{helpdesk_name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl": "{{githubUrl}}",
                            "attachments": "",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.subject}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": "{{ticket.id}}",
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "githubUrl": "{{githubUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{ticket.agent.id}}",
                                "email": "{{ticket.agent.email}}",
                                "name": "{{ticket.agent.name}}"
                            }
                        }
                    }
                    break;
                    case 'freshservice-github':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{hdLoginUrl}}/helpdesk/tickets/{{ticket.id}}",
                            "brandname": "{{helpdesk_name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl": "{{githubUrl}}",
                            "attachments": "",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.subject}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": "{{ticket.id}}",
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "githubUrl": "{{githubUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{ticket.agent.id}}",
                                "email": "{{ticket.agent.email}}",
                                "name": "{{ticket.agent.name}}"
                            }
                        }
                    }
                    break;
            }

            hdJSONString=JSON.stringify(hdJSONString);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{githubUrl}}",item.githubUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{appId}}",item.appId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{installationId}}",item.installationId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{requestType}}",item.requestType);
            console.log(JSON.parse(hdJSONString));
            _self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        copySyncDocsUrl(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/el/sync-setup/github/${item.requestType}/${item.userId}/${item.appId}/${item.installationId}/${item.userEmail}/${account}?appId=${item.appId}&installationId=${item.installationId}&account=${account}`;
            _self.doCopyVal(url,'Sync Docs URL copied');
            setTimeout(function(){
                window.open(url,'_blank');
            },2500);
        },
        copyHDAutoCreateURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/${type}/create?appId=${item.appId}&installationId=${item.installationId}&account=${account}`;
            
            _self.doCopyVal(url,'HD Auto Create URL copied');
        },
        //ado to hd ticket create
        copyGitHubCreateHDURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/github/create?appId=${item.appId}&installationId=${item.installationId}`;
            
            _self.doCopyVal(url,'GitHub Create HD URL copied');
        },
        //hd
        copyHDArticleLink(item){
            const _self=this;
            let hdArticleLink='';
            switch(item.requestType){
                case 'zendesk-github':
                    hdArticleLink = 'https://docs.google.com/document/d/1ssMynJDkkBKggGcMZMfqmU6M9O9Sl5_gQ8Su9koC-C4/edit?usp=sharing';
                break;
                case 'freshdesk-github':
                    hdArticleLink ='https://docs.google.com/document/d/1oLmRLY42ys6NPuEQULcDcq56MkRBhlIKQWrg4EcqDyE/edit?usp=sharing';
                break;
                case 'freshservice-github':
                    hdArticleLink ='https://docs.google.com/document/d/198e-X0XOM6jMw_hi9crAwxfqKljOHlM1yMYRY1pywHw/edit?usp=sharing';
                break;
                case 'github':
                    hdArticleLink = 'https://docs.google.com/document/d/1MqwIqanbk56KZ0JceHJC7lH-kLR_vUg6lXwkfW5ps1Q/edit?usp=sharing';
                    break;
            }

            _self.doCopyVal(hdArticleLink,'HD Article Link copied');
        },
        copyHDSyncJSON(item){
            const _self=this;
            let hdJSONString;
            switch(item.requestType){
                case 'zendesk-github':
                    hdJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "comment_id":"{{ticket.latest_comment.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "account":"{{ticket.account}}",
                            "ticket_status":"{{ticket.status}}",
                            "brandname":"{{ticket.brand.name}}",
                            "current_username":"{{current_user.name}}",
                            "current_useremail":"{{current_user.email}}",
                            "current_user_first_name":"{{current_user.first_name}}",
                            "ticket_latest_comment_formatted":"{{ticket.latest_comment_formatted}}",
                            "ticket_latest_comment":"{{ticket.latest_comment}}",
                            "is_public":"{{ticket.latest_comment.is_public}}",
                            "attachments":"{{ticket.latest_comment.attachments}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl":"{{githubUrl}}"
                        }
                    }
                    break;
                    case 'freshdesk-github':
                    hdJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            //"latest_comment": "{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment": "{{ticket.latest_private_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "ticket_agent_name": "{{ticket.agent.name}}",
                            "ticket_agent_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl": "{{githubUrl}}"
                        }
                    }
                    break;
                    case 'freshservice-github':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "ticket_latest_private_comment":"{{ticket.latest_private_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "githubUrl": "{{githubUrl}}"
                        }
                    }
                    break;
            }

            hdJSONString=JSON.stringify(hdJSONString);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{githubUrl}}",item.githubUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{appId}}",item.appId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{installationId}}",item.installationId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{requestType}}",item.requestType);
            console.log(JSON.parse(hdJSONString));
            _self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        copyHDSyncURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/${type}/syncing?appId=${item.appId}&installationId=${item.installationId}&account=${account}`
            _self.doCopyVal(url,'HD Syncing URL copied');
        },
        //github
        copyGitHubArticleLink(item){
            const _self=this;
            let githubArticleLink='';
            switch(item.requestType){
                case 'zendesk-github':
                    githubArticleLink='https://docs.google.com/document/d/169BfKDscRBfpRyMgEZXpS0inLToPCAbarwyZgCeQ57s/edit?usp=sharing';
                break;
                case 'freshdesk-github':
                    githubArticleLink='https://docs.google.com/document/d/1mC84XrdUwOiR5izSAf7Gn3l6tbqsH6i4I-HrXB9eBs0/edit?usp=sharing';
                break;
                case 'freshservice-github':
                    githubArticleLink='https://docs.google.com/document/d/1HQAyKoIfX45kiL5a-iIYPUHe8mosJaadfrG26kTtsag/edit?usp=sharing';
                break;
            }
            _self.doCopyVal(githubArticleLink,'GitHub Article Link copied');
        },
        copyGitHubCommentURL(item){
            const _self=this;
            let url = `https://devopsintegration.io/api/${item.requestType}/github/syncing?appId=${item.appId}&installationId=${item.installationId}&userId=${item.userId}`
            _self.doCopyVal(url,'GitHub Comment URL copied');
        },
        copyGitHubStatusURL(item){
            const _self=this;
            //let url=`https://devopsintegration.io/api/freshdesk-github/github/syncing?appId=fd_118&installationId=fd_118`
            let url = `https://devopsintegration.io/api/${item.requestType}/github/syncing?appId=${item.appId}&installationId=${item.installationId}&userId=${item.userId}`
            _self.doCopyVal(url,'GitHub Status URL copied')
        }
    }
});
</script>
